import { useRef, useState } from "react";

const DragScrollTabsComponent = ({ categoriasData = [], categoriaSeleccionada, setCategoriaSeleccionada }) => {
    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setStartX(e.pageX - scrollRef.current.offsetLeft);
        setScrollLeft(scrollRef.current.scrollLeft);
    };

    const handleMouseLeave = () => setIsDragging(false);
    const handleMouseUp = () => setIsDragging(false);

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault(); // previene selección de texto
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX) * 1.5; // velocidad del drag
        scrollRef.current.scrollLeft = scrollLeft - walk;
    };

    return (
        <div
            ref={scrollRef}
            className="filter-tabs my-4 shadow-default wow fadeInUp"
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            onMouseMove={handleMouseMove}
        >
            {categoriasData.map((cat, index) => (
                <button
                    key={index}
                    onClick={() => setCategoriaSeleccionada(cat)}
                    className={`tab-item ${categoriaSeleccionada == cat ? "tab-active" : ""}`}
                >{cat}</button>
            ))}
        </div>
    );
};

export default DragScrollTabsComponent;
